import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import cn from 'classnames';

import { Row, Col } from 'react-bootstrap';

import Logo from '../event_components/logo';
import Title from '../event_components/title';
import Location from '../event_components/location';
import Time from '../event_components/time';
import styles from './mobile.scss';
import GoogleLocation from '../event_components/google_location';
import AttendButton from '../event_components/attend_button';
import TicketPurchasing from '../event_components/ticket-purchasing';
import AddEventToCalendar from '../event_components/add_to_calendar';
import { LocaleWrapper } from '../../locale-wrapper';
import PaddedComponent from './top_padder';
import { attendButtonIsVisible } from './utils';
import CheckoutController from 'widget/event_components/Checkout';

function Venue({ event, settings }) {
  return event.get('type') === 'google' ? <GoogleLocation event={event} /> : <Location settings={settings} disableLink event={event} />;
}
class Mobile extends React.Component {
  constructor() {
    super();
    this.state = {
      openTicketing: false,
    };
  }
  toggleAttendButton = () => {
    this.props.onResizeComponent();
    this.setState({
      openTicketing: !this.state.openTicketing,
    });
  };
  render() {
    const { settings, event, onResizeComponent } = this.props;

    const showLogo = settings.get('showEventLogo') && event.getIn(['logo', 'url']);
    return (
      <CheckoutController
        variant="default"
        event={event}
        settings={settings}
        openTicketing={this.state.openTicketing}
        onResizeComponent={onResizeComponent}
        onClose={() => {
          this.setState({
            openTicketing: false,
          });
        }}
      >
        <div className={cn(styles.mobileEvent, styles.padded, 'event', 'side-by-side')}>
          <Row className={cn(styles.mobile, styles.center)} center="xs" middle="xs">
            <Col xs={showLogo ? 7 : 12}>
              <Title event={event} className={styles.paddingLeft} settings={settings} />
            </Col>
            {showLogo && (
              <Col xs={5} className={styles.logo}>
                <Logo event={event} className={styles.image} settings={settings} />
              </Col>
            )}
          </Row>
          <Row className={styles.content}>
            <Col xs={12}>
              <PaddedComponent>
                <Time event={event} settings={settings} className={styles.time} format="MMM D" />
              </PaddedComponent>
            </Col>
            {(settings.get('enableAddToCalendar') || settings.get('showVenue') || settings.get('showFullAddress')) && (
              <Col xs={12} style={{ textAlign: 'center' }}>
                <PaddedComponent>
                  {settings.get('enableAddToCalendar') && <AddEventToCalendar event={event} settings={settings} />}
                  {settings.get('showVenue') && <Venue event={event} settings={settings} />}
                </PaddedComponent>
              </Col>
            )}
            <Col xs={12}>
              <PaddedComponent>
                {attendButtonIsVisible(event, settings) && (
                  <AttendButton event={event} settings={settings} handleButtonClick={this.toggleAttendButton} />
                )}
                {settings.get('embedTicketPurchasing') && (
                  <TicketPurchasing settings={settings} event={event} open={this.state.openTicketing} key={event.get('id')} />
                )}
              </PaddedComponent>
            </Col>
          </Row>
        </div>
      </CheckoutController>
    );
  }
}

Mobile.propTypes = {
  event: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
};

function MobileLightweightContainer({ event, settings, onResizeComponent }) {
  return (
    <LocaleWrapper event={event}>
      {settings.get('removeAttendButton') && !settings.get('removeUrlLink') ? (
        <a href={event.get('url')} target="_blank" rel="noopener noreferrer">
          <Mobile event={event} settings={settings} onResizeComponent={onResizeComponent} />
        </a>
      ) : (
        <Mobile event={event} settings={settings} onResizeComponent={onResizeComponent} />
      )}
    </LocaleWrapper>
  );
}

export default MobileLightweightContainer;
